import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import DepartmentCreatePopup from "../../components/popups/DepartmentCreatePopup";
import DesignationCreatePopup from "../../components/popups/DesignationCreatePopup";
import { fetchAllDesignations } from "../../store/slices/userSlice";
import { fetchAllDepartments } from "../../store/slices/departmentSlice";


function EditJobDetails({ clientData, onDataChange }) {
  const dispatch = useDispatch();
  const { departmentList, designationList } = useSelector((state) => state.user);

  const [showDepartmentCreatePopup, setShowDepartmentCreatePopup] = useState(false);
  const [showDesignationCreatePopup, setShowDesignationCreatePopup] = useState(false);

  const selectedDepartmentId = clientData?.departmentId || "";
  const departmentSelectValue = useMemo(() => selectedDepartmentId, [selectedDepartmentId]);

  const [selectedPayType, setSelectedPayType] = useState(clientData?.payType || "");




  useEffect(() => {
    dispatch(fetchAllDepartments());
    dispatch(fetchAllDesignations());
  }, [dispatch]);

  useEffect(() => {
    setSelectedPayType(clientData?.payType || "");
  }, [clientData?.payType]);

  const handleChange = (field, value) => {
    if (onDataChange) onDataChange({ [field]: value });
  };

  const handlePayTypeChange = (value) => {
    setSelectedPayType(value);
    handleChange("payType", value);
  };

  const handleDepartmentChange = (e) => {
    const value = e?.target?.value ?? "";
    if (value === "__add_new__") {
      setShowDepartmentCreatePopup(true);
      // keep existing department selected
      handleChange("departmentId", departmentSelectValue);
      return;
    }
    handleChange("departmentId", value);
  };

  const handleDepartmentCreated = ({ id }) => {
    if (!id) return;
    onDataChange?.({ departmentId: id });
    setShowDepartmentCreatePopup(false);
  };


  return (
    <>
      <DesignationCreatePopup
        show={showDesignationCreatePopup}
        onClose={() => setShowDesignationCreatePopup(false)}
        onCreated={({ id }) => {
          if (!id) return;
          onDataChange?.({ designationId: id });
          setShowDesignationCreatePopup(false);
        }}
      />

      <DepartmentCreatePopup
        show={showDepartmentCreatePopup}
        onClose={() => setShowDepartmentCreatePopup(false)}
        onCreated={({ id }) => {
          if (!id) return;
          handleDepartmentCreated({ id });
        }}
      />

      <div className="editpresoldetail mb_20">

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="white_card">
                <div className="row">
                  {/* TITLE */}
                  <div className="col-md-2">
                    <h4 className="mt_20">Job Details</h4>
                  </div>

                  {/* LEFT COLUMN */}
                  <div className="col-md-5">
                    <div className="common_input_forms">
                      <div className="form_group">
                        <label>Designation</label>
                        <div className="dropdown select_dropdown">
                          <select
                            className="form-control pl_16"
                            value={clientData?.designationId || ""}
                            onChange={(e) => {
                              const value = e?.target?.value ?? "";
                              if (value === "__add_new__") {
                                setShowDesignationCreatePopup(true);
                                // keep existing selection until user picks the new value
                                handleChange("designationId", clientData?.designationId || "");
                                return;
                              }
                              handleChange("designationId", value);
                            }}
                          >
                            <option value="">Select Designation</option>
                            {designationList?.map((d) => (
                              <option key={d.id} value={d.id}>
                                {d.name}
                              </option>
                            ))}
                            <option value="__add_new__">+ Add new designation</option>
                          </select>
                        </div>
                      </div>

                      <div className="form_group">
                        <label>Department</label>
                        <div className="dropdown select_dropdown">
                          <select
                            className="form-control pl_16"
                            value={clientData?.departmentId || ""}
                            onChange={handleDepartmentChange}
                          >
                            <option value="">Select Department</option>
                            {departmentList?.map((d) => (
                              <option key={d.id} value={d.id}>
                                {d.name}
                              </option>
                            ))}
                            <option value="__add_new__">+ Add new department</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* MIDDLE COLUMN */}
                  <div className="col-md-5">
                    <div className="common_input_forms">
                      <div className="form_group">
                        <label>Pay Type</label>
                        <select
                          className="form-control form-select pl_16"
                          value={selectedPayType}
                          onChange={(e) => handlePayTypeChange(e.target.value)}
                        >
                          <option value="">Select PayType</option>
                          <option value="Hourly">Hourly</option>
                          <option value="Salary">Salary</option>
                        </select>
                      </div>

                      {selectedPayType === "Hourly" && (
                        <>
                          <div className="form_group">
                            <label>Hourly Rate</label>
                            <input
                              type="text"
                              className="form-control pl_16"
                              placeholder="Enter Hourly Rate"
                              value={clientData?.hourlyRate || ""}
                              onChange={(e) => handleChange("hourlyRate", e.target.value)}
                            />
                          </div>

                          <div className="form_group">
                            <label>Regular Hours</label>
                            <input
                              type="text"
                              className="form-control pl_16"
                              placeholder="Enter Regular Hours"
                              value={clientData?.defaultRegularHours || ""}
                              onChange={(e) => handleChange("defaultRegularHours", e.target.value)}
                            />
                          </div>
                        </>
                      )}

                      {selectedPayType === "Salary" && (
                        <div className="form_group">
                          <label>Fixed Salary</label>
                          <input
                            type="text"
                            className="form-control pl_16"
                            placeholder="Enter Fixed Salary"
                            value={clientData?.fixedSalary || ""}
                            onChange={(e) => handleChange("fixedSalary", e.target.value)}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* RIGHT COLUMN - Empty for now, can be used for additional fields if needed */}
                  <div className="col-md-5">
                    <div className="common_input_forms">
                      {/* Additional fields can be added here if needed */}
                    </div>
                  </div>
                </div>

                {/* BUTTON ROW (same as old design) */}
                <div className="row">
                  <div className="col-md-12">
                    <a href="#" className="btn_primary"></a>
                  </div>
                </div>
                {/* END BUTTON */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default EditJobDetails;
